package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{className, div}

@react object WaitIcon {
	case class Props
	(
		centered: Boolean = true
	)

	val component = FunctionalComponent[Props] { props =>
		val dots =
			div(className := "nfw-spinner")(
				div(className := "nfw-spinner-dot"),
				div(className := "nfw-spinner-dot"),
				div(className := "nfw-spinner-dot")
			)
		if (props.centered)
			div(className := "nfw-centered-container")(dots)
		else dots
	}
}
